import { invokeAPI } from '@shared/invokeAPI';
import { EventsState } from '@shared/state/events';
import { updateStore } from '@shared/state/updateStore';
import { ScheduledEvent } from '@shared/types';

export function fetchEvents(): Promise<Array<ScheduledEvent> | void> {
  updateState({ isBusy: true });
  return (
    invokeAPI<Array<ScheduledEvent>>('getEvents')
      .then(({ data }) => {
        updateState({ isBusy: false });
        return data;
      })
      .catch(handleError)
  );
}

function handleError(error: any): void {
  updateState({ isBusy: false, error: String(error) });
}

function updateState(updates: Partial<EventsState>): void {
  updateStore('events', updates);
}
